import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_position",
  "use": "icon-map_position-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"icon-map_position\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M.5 0h24v24H.5z\" /><path d=\"M7.5 6V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h4Zm-3 9h16v2h-16v-2Zm5-11v2h6V4h-6Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol